import { useTranslation } from "react-i18next"
import Stack from "@mui/material/Stack"
import { styled } from "@mui/material/styles"
import Typography from "@mui/material/Typography"
import { formatRelativeDate } from "utils/dateUtils"
import { NAVIGATE_TO_OTHER_USER_PROFILE_PAGE } from "constants/events"
import Avatar from "components/atoms/Avatar"
import CommentsLoadingPlaceholder from "components/organisms/WishItemBottomSection/CommentsLoadingPlaceholder"

type CommentsProps = {
  comments: WishamComment[];
  count: number;
  isFetching: boolean;
}

export default function CommentsList(props: CommentsProps) {
  const { comments, count, isFetching } = props

  const { t } = useTranslation()

  function navigateToUserProfile(handle: string) {
    const eventDetail = { handle }
    document.dispatchEvent(new CustomEvent(NAVIGATE_TO_OTHER_USER_PROFILE_PAGE, { detail: eventDetail }))
  }

  return (
    <Container>
      {isFetching ? <CommentsLoadingPlaceholder/> : <>
        {count ? <Stack>
            {comments.map((comment, index) => (
              <Stack key={index}>
                <Stack direction="row" gap="8px" marginTop="10px">
                  <AvatarWrapper onClick={() => navigateToUserProfile(comment.authorName)}>
                    <Avatar imageSrc={comment.avatar}/>
                  </AvatarWrapper>
                  <Stack width="100%">
                    <Stack
                      direction="row"
                      justifyContent="space-between"
                      alignItems="center"
                    >
                      <AuthorName onClick={() => navigateToUserProfile(comment.authorName)}>{comment.authorName}</AuthorName>
                      <Date className="farsi-digits">{formatRelativeDate(comment.createdAt.toString())}</Date>
                    </Stack>
                    <Content>{comment.content}</Content>
                  </Stack>
                </Stack>
              </Stack>
            ))}
          </Stack> :
          <NoComment>{t("items.noCommentFound")}</NoComment>
        }
      </>}
    </Container>
  )
}


const Container = styled(Stack)(({ theme }) => ({
  width: "100%",
  height: "100%",
  overflowY: "scroll",
  padding: "0 4px"
}))

const NoComment = styled("div")(({ theme }) => ({
  width: "100%",
  textAlign: "center",
  fontSize: "1.2rem",
  color: theme.palette.gray["13"],
  marginTop: "16px"
}))

const AuthorName = styled(Typography)(({ theme }) => ({
  fontSize: "1.2rem",
  fontWeight: 500,
  color: theme.palette.gray["15"]
}))

const Date = styled(Typography)(({ theme }) => ({
  fontSize: "1rem",
  fontWeight: 400,
  color: theme.palette.gray["13"]
}))

const Content = styled(Typography)(({ theme }) => ({
  fontSize: "1rem",
  fontWeight: 400,
  color: theme.palette.gray["15"],
  marginBottom: "12px",
  whiteSpace: "break-spaces"
}))

const AvatarWrapper = styled("div")(({ theme }) => ({
  width: "32px",
  height: "32px"
}))
